import request from '@/utils/request'
// 轮播图
export function createCarousel(data) {
    return request({
        url: '/display/createCarousel',
        method: 'post',
        data,
    })
}
export function updateCarousel(data) {
    return request({
        url: '/display/updateCarousel',
        method: 'post',
        data,
    })
}
export function removeCarousel(data) {
    return request({
        url: '/display/removeCarousel',
        method: 'post',
        data,
    })
}
export function findCarouselList(params) {
    return request({
        url: '/display/findCarouselList',
        method: 'get',
        params,
    })
}
//横幅
export function createBanner(data) {
    return request({
        url: '/display/createBanner',
        method: 'post',
        data,
    })
}
export function updateBanner(data) {
    return request({
        url: '/display/updateBanner',
        method: 'post',
        data,
    })
}
export function removeBanner(data) {
    return request({
        url: '/display/removeBanner',
        method: 'post',
        data,
    })
}
export function findBannerList(params) {
    return request({
        url: '/display/findBannerList',
        method: 'get',
        params,
    })
}
// 文章
export function createArticle(data) {
    return request({
        url: '/display/createArticle',
        method: 'post',
        data,
    })
}
export function updateArticle(data) {
    return request({
        url: '/display/updateArticle',
        method: 'post',
        data,
    })
}
export function removeArticle(data) {
    return request({
        url: '/display/removeArticle',
        method: 'post',
        data,
    })
}
export function findArticleList(params) {
    return request({
        url: '/display/findArticleList',
        method: 'get',
        params,
    })
}
//获取单个文章 get display/findArticle，参数：
// articleId
export function findArticle(params) {
    return request({
        url: '/display/findArticle',
        method: 'get',
        params,
    })
}

// 获取落地页列表
export function getPageList(params) {
    return request({
        url: '/display/findPageList',
        method: 'get',
        params,
    })
}
// 新增落地页
export function createPage(data) {
    return request({
        url: '/display/createPage',
        method: 'post',
        data,
    })
}
// 编辑落地页
export function editPage(data) {
    return request({
        url: '/display/updatePage',
        method: 'post',
        data,
    })
}
// 删除落地页
export function delPage(data) {
    return request({
        url: '/display/removePage',
        method: 'post',
        data,
    })
}